import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from '@mui/styles';
import { Dialog, DialogActions, DialogTitle, DialogContent, Button, Typography, Grid, CircularProgress, Box, Input, TextField } from "@mui/material";
import theme from "../../theme.css";
import wsclients from "../../services/wsclients";
import { getAddressHome } from "../../utils/commons";
import CustomLoading from "../../components/CustomLoading";

const useStyles = makeStyles((theme) => ({
    paperXs: {
        width: 500
    },
    paperSm: {
        width: 600
    },
    paperMd: {
        width: 900
    },
    paperLg: {
        width: 1000
    },
    paperXl: {
        width: 1200
    },
    title: {
        borderBottom: '1px solid ' + theme.palette.background.primary,
        paddingBottom: theme.spacing(1),
    },
    content: {
        marginTop: theme.spacing(2)
    },
    address_item: {
        cursor: 'pointer',
        padding: theme.spacing(1),
        borderBottom: '1px solid ' + theme.palette.background.primary,
    },
    address_selected: {
        backgroundColor: theme.palette.background.primary,
    },
    list_items: {
        overflow: 'auto',
        [theme.breakpoints.down('xl')]: {
            maxHeight: '50vh',
        },
        [theme.breakpoints.down('sm')]: {
            maxHeight: '30vh',
        },
    }
}));

export default function ModalONT(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [ontValue, setONTValue] = useState(null);
    const [isValid, setIsValid] = useState(false);
    const [showProcessing, setShowProcessing] = useState(false);
    const { open, setEnableCheckout } = props;
    console.log("AAAA ModalONT props: ", props)

    const onVerify = async () => {
        let address = getAddressHome();
        console.log("AAAA ontValue: ", ontValue)
        setShowProcessing(true)
        try {
            let result = await wsclients.lab4services.verifyONTOfLines({
                lat: address && address.latitude,
                lng: address && address.longitude,
                uuid: address && address.premisesid,
                ont: ontValue,
            })
            console.log("AAAA result: ", result)
            if (result.code == 'OK') {
                if (result.data && result.data.ont_reconnect_valid) {
                    setIsValid(false)
                    setEnableCheckout(true)
                    props.confirmAction({ ont: result.data.ont_serial, line_uuid: result.data.line_uuid })
                }
                else {
                    setIsValid(true);
                    setEnableCheckout(true)
                }
            }
        } catch (error) {
            console.log("AAAA onVerify error: ", error)
        }
        setShowProcessing(false)
    }
    
    return (
       <>
            <Dialog
                open={open}
                maxWidth={'xs'}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                classes={{
                    paper: classes.paperXs,
                }}
            >
                {showProcessing && <CustomLoading open={showProcessing}/>}
                <DialogTitle id="alert-dialog-title" className={classes.title}>
                    {t('Verify ONT')}
                </DialogTitle>
                <DialogContent className={classes.content}>
                    <Typography marginBottom={1}>{"Please enter ONT to verify"}</Typography>
                    <TextField type="text" name="ont" 
                        size="small"
                        autoComplete="false"
                        onChange={(e) => {setONTValue(e.target.value); setIsValid(false)}} 
                        autoFocus={true}
                        style={{ width: '100%' }}
                    />
                    {isValid && <Typography color="error" variant="caption">ONT invalid</Typography>}
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" disabled={!ontValue} onClick={() => onVerify()}>
                        {t('Verify')}
                    </Button>
                    <Button variant="outlined" onClick={() => props.onClose()}>
                        {t('btn_cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
       </>
    )
}